export default __webpack_public_path__ + "static/media/lynnHTPMb.1031e563.png";